/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type ImportRisksMutationVariables = Types.Exact<{
  object: Types.ImportRisksInput;
}>;

export type ImportRisksMutation = { __typename?: 'mutation_root'; import_risks: string };

export const ImportRisksDocument = `
    mutation ImportRisks($object: ImportRisksInput!) {
  import_risks(object: $object)
}
    ` as string & TypedDocumentNode<ImportRisksMutation, ImportRisksMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    ImportRisks: build.mutation<ImportRisksMutation, ImportRisksMutationVariables>({
      query: (variables) => ({ document: ImportRisksDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useImportRisksMutation } = injectedRtkApi;
